import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-text" }
const _hoisted_3 = ["src"]

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import DropdownCheckboxMapMenu, {
  optionType
} from '@/components/general/selectors/DropdownMapMenu/checkbox/DropdownCheckboxMapMenu.vue'

const headerIconId = 'poi-header-icon'

// DropdownCheckboxMapMenu content

export default /*@__PURE__*/_defineComponent({
  __name: 'IndoorviewerMenuPoi',
  setup(__props) {

const store = useStore()
const { t } = useI18n()

// Header content
const title = computed<string>(() => {
  if (!poiTypes.value.length) return t('general__text__selection-no-groups-available')
  return `${t('general__text__select')} ${t('general__text__category').toLowerCase()}`
})
const headerIconSrc = computed<string>(() => {
  return anyPoiVisible.value
    ? require('@/assets/icons-general/icon-visibility-visible.svg')
    : require('@/assets/icons-general/icon-visibility-hidden.svg')
})
const anyPoiVisible = computed<boolean>(() => {
  return poiOptions.value.some((option) => option.checked)
})
const poiTypes = computed(() => store.state.iv.poiTypes)

const poiOptions = computed<optionType[]>(() => {
  const options: optionType[] = []
  poiTypes.value.forEach((group) => {
    if (group.name.en === undefined) return
    options.push({
      id: `123456789${group.id.toString()}`,
      checked: group.visible,
      value: group.name.en,
      isHeading: true
    })
    group.types.forEach((type) => {
      if (type.name.en === undefined) return
      options.push({
        id: type.id.toString(),
        checked: type.visible,
        value: type.name.en,
        iconSource: type.iconSrc
      })
    })
  })
  return options
})

// Toggle logic
function onToggle(id: string) {
  const option = poiOptions.value.find((option) => option.id === id)
  if (!option) return
  if (option?.isHeading)
    store.dispatch('iv/togglePoiGroup', { id: parseInt(id.substring(9)), visible: !option.checked })
  else store.dispatch('iv/togglePoiType', { id: parseInt(id), visible: !option.checked })
}
function onToggleAllTypes(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  const updatedVisibility = !anyPoiVisible.value
  poiOptions.value.forEach((option) => {
    if (!option.isHeading) return
    store.dispatch('iv/togglePoiGroup', {
      id: parseInt(option.id.substring(9)),
      visible: updatedVisibility
    })
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('general__text__pois')), 1),
      _createElementVNode("img", {
        id: headerIconId,
        alt: "icon-poi-visibility",
        class: "header-icon",
        role: "button",
        src: headerIconSrc.value,
        tabindex: "0",
        onClick: onToggleAllTypes,
        onKeydown: [
          _withKeys(onToggleAllTypes, ["enter"]),
          _cache[0] || (_cache[0] = _withKeys((event) => onToggleAllTypes(event, true), ["space"]))
        ]
      }, null, 40, _hoisted_3)
    ]),
    _createVNode(DropdownCheckboxMapMenu, {
      title: title.value,
      options: poiOptions.value,
      preventCloseElementIds: [headerIconId],
      onToggleOption: onToggle
    }, null, 8, ["title", "options", "preventCloseElementIds"])
  ], 64))
}
}

})